/* Read actual native details state, including Escape, Apply and AJAX replacement. */
(() => {
  let scheduled = false;
  function sync() {
    scheduled = false;
    document.documentElement.classList.toggle('lc-filter-open', !!document.querySelector('.mobile-facets__disclosure[open]'));
    document.querySelectorAll('.mobile-facets__details').forEach((group) => {
      const badge = group.querySelector('.lc-filter-count');
      if (!badge) return;
      const checked = group.querySelectorAll('input[type="checkbox"]:checked').length;
      const price = [...group.querySelectorAll('price-range input[name]')].some(input => input.value !== '');
      const count = checked || (price ? 1 : 0);
      if (badge.textContent !== String(count)) badge.textContent = String(count);
      badge.hidden = !count;
    });
  }
  function schedule() {
    if (!scheduled) { scheduled = true; requestAnimationFrame(sync); }
  }
  document.addEventListener('toggle', event => {
    if (event.target.matches('.mobile-facets__disclosure')) sync();
  }, true);
  document.addEventListener('input', event => {
    if (event.target.closest('.mobile-facets__wrapper')) schedule();
  });
  new MutationObserver(records => {
    if (records.some(record => record.type === 'attributes' ||
      (record.target.nodeType === 1 && !record.target.closest('.lc-filter-count') &&
       (record.target.closest('.mobile-facets__wrapper') || [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 && (node.matches('.mobile-facets__wrapper') || node.querySelector('.mobile-facets__wrapper'))))))) schedule();
  }).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['open']});
  window.addEventListener('pageshow', sync);
  document.addEventListener('shopify:section:load', schedule);
  sync();
})();
